import { render, staticRenderFns } from "./formdate.vue?vue&type=template&id=a26c4aa4&"
import script from "./formdate.vue?vue&type=script&lang=js&"
export * from "./formdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports